
export default function DownloadableResourcesSection() {
  const resources = [
    {
      title: 'SETA Compliance Requirements Guide',
      description: 'Complete guide to Skills Development Act requirements, deadlines, and compliance procedures',
      fileSize: '2.4 MB',
      icon: 'ri-file-pdf-line',
      category: 'Compliance'
    },
    {
      title: 'Sylman Academy Capability Statement',
      description: 'Comprehensive overview of our training capabilities, accreditations, and service offerings',
      fileSize: '1.8 MB',
      icon: 'ri-file-pdf-line',
      category: 'Company Profile'
    },
    {
      title: 'Training Programme Catalogue',
      description: 'Full programme list with detailed course descriptions, durations, and learning outcomes',
      fileSize: '3.2 MB',
      icon: 'ri-file-pdf-line',
      category: 'Programmes'
    },
    {
      title: 'Corporate Training Packages Brochure',
      description: 'Detailed payment options, package comparisons, and customisation possibilities',
      fileSize: '2.1 MB',
      icon: 'ri-file-pdf-line',
      category: 'Corporate'
    },
    {
      title: 'SETA Funding Application Templates',
      description: 'Ready-to-use templates for WSP, ATR, and discretionary grant applications',
      fileSize: '1.5 MB',
      icon: 'ri-file-pdf-line',
      category: 'Funding'
    },
    {
      title: 'Skills Development Planning Toolkit',
      description: 'Strategic planning tools and templates for effective workforce development',
      fileSize: '2.8 MB',
      icon: 'ri-file-pdf-line',
      category: 'Planning'
    }
  ];

  return (
    <section className="section-wrap bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="section-heading">
            Downloadable Resources
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Access our comprehensive library of guides, templates, and planning tools
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {resources.map((resource, index) => (
            <div key={index} className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 bg-red-100 text-red-600 rounded-lg flex items-center justify-center">
                  <i className={`${resource.icon} text-xl`}></i>
                </div>
                <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
                  {resource.category}
                </span>
              </div>
              
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                {resource.title}
              </h3>
              
              <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                {resource.description}
              </p>
              
              <div className="flex items-center justify-between">
                <span className="text-xs text-gray-500">{resource.fileSize}</span>
                <button className="btn btn-primary btn-sm">
                  Download PDF
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="bg-gray-50 p-8 rounded-xl">
            <div className="w-16 h-16 bg-[#2D7F3E] text-white rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-download-cloud-line text-2xl"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Need a Custom Resource?
            </h3>
            <p className="text-gray-600 mb-4">
              We can create tailored guides and documentation specific to your industry or training needs
            </p>
            <button className="btn btn-primary">
              Request Custom Resource
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
